var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetSuccessSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.972046,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E4EBF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7454 34.6388C55.8327 36.389 55.8327 38.4711 55.8327 40.9721C55.8327 48.436 55.8327 52.168 53.5139 54.4867C51.1952 56.8055 47.4633 56.8055 39.9993 56.8055C32.5354 56.8055 28.8035 56.8055 26.4848 54.4867C24.166 52.168 24.166 48.436 24.166 40.9721C24.166 33.5082 24.166 29.7763 26.4848 27.4575C28.8035 25.1388 32.5354 25.1388 39.9993 25.1388C41.7859 25.1388 43.3586 25.1388 44.7493 25.1706",
    stroke: "#6950F3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 40.1388C33.333 40.1388 35.833 40.1388 39.1663 45.9721C39.1663 45.9721 47.5977 30.6943 55.833 27.6388",
    stroke: "#6950F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSuccessSvg);
export default __webpack_public_path__ + "static/media/resetSuccessSVG.c908570c377e990d41dabe04cefbe6ac.svg";
export { ForwardRef as ReactComponent };